import { createSlice } from "@reduxjs/toolkit";
import { getOrders } from "../../reduxApi/admin/OrdersReduxApi";
import { getProductReviewApi } from "../../reduxApi/admin/ProductReviewApi";

const AdminProductReviewSlice = createSlice({
  name: "AdminProductReview",
  initialState: {
    status: "idle",
    getProductReview: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductReviewApi.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getProductReviewApi.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.getProductReview = action.payload.data.reviews;
        console.log("getProductReview", action.payload.data.reviews);
      });
  },
});

export default AdminProductReviewSlice.reducer;
